import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import ServicosPage from "@/pages/ServicosPage";
import ClinicaPage from "@/pages/ClinicaPage";
import MarcarConsultaPage from "@/pages/MarcarConsultaPage";
import MarcacaoTokenPage from "@/pages/MarcacaoTokenPage";
import ContactosPage from "@/pages/ContactosPage";
import SobrePage from "@/pages/SobrePage";
import SetupPasswordPage from "@/pages/SetupPasswordPage";
import ScrollToTop from "@/components/ScrollToTop";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider } from "@/admin/AuthContext";
import RequireAdmin from "@/admin/RequireAdmin";
import AdminShell from "@/admin/AdminShell";
import AdminLoginPage from "@/admin/pages/AdminLoginPage";
import AdminDashboardPage from "@/admin/pages/AdminDashboardPage";
import AdminMarcacoesPage from "@/admin/pages/AdminMarcacoesPage";
import AdminMarcacaoDetailPage from "@/admin/pages/AdminMarcacaoDetailPage";
import AdminAgendaPage from "@/admin/pages/AdminAgendaPage";
import AdminMensagensPage from "@/admin/pages/AdminMensagensPage";
import AdminDefinicoesPage from "@/admin/pages/AdminDefinicoesPage";
import AdminServicosPage from "@/admin/pages/AdminServicosPage";
import { AdminClientesPage, AdminClienteDetailPage } from "@/admin/pages/AdminClientesPages";
import AdminMedicosPage from "@/admin/pages/AdminMedicosPage";
import AdminDisponibilidadePage from "@/admin/pages/AdminDisponibilidadePage";
import AdminUtilizadoresPage from "@/admin/pages/AdminUtilizadoresPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AuthProvider>
          <Routes>
            {/* Public */}
            <Route path="/" element={<HomePage />} />
            <Route path="/sobre" element={<SobrePage />} />
            <Route path="/servicos" element={<ServicosPage />} />
            <Route path="/clinicas/:slug" element={<ClinicaPage />} />
            <Route path="/marcar-consulta" element={<MarcarConsultaPage />} />
            <Route path="/marcacao/:token" element={<MarcacaoTokenPage />} />
            <Route path="/contactos" element={<ContactosPage />} />
            <Route path="/criar-password/:token" element={<SetupPasswordPage />} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route element={<RequireAdmin />}>
              <Route element={<AdminShell />}>
                <Route path="/admin" element={<AdminDashboardPage />} />
                <Route path="/admin/marcacoes" element={<AdminMarcacoesPage />} />
                <Route path="/admin/marcacoes/:id" element={<AdminMarcacaoDetailPage />} />
                <Route path="/admin/agenda" element={<AdminAgendaPage />} />
                <Route path="/admin/mensagens" element={<AdminMensagensPage />} />
                <Route path="/admin/servicos" element={<AdminServicosPage />} />
                <Route path="/admin/clientes" element={<AdminClientesPage />} />
                <Route path="/admin/clientes/:id" element={<AdminClienteDetailPage />} />
                <Route path="/admin/medicos" element={<AdminMedicosPage />} />
                <Route path="/admin/disponibilidade" element={<AdminDisponibilidadePage />} />
                <Route path="/admin/utilizadores" element={<AdminUtilizadoresPage />} />
                <Route path="/admin/definicoes" element={<AdminDefinicoesPage />} />
              </Route>
            </Route>

            <Route path="*" element={<HomePage />} />
          </Routes>
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
